import { Link } from '@/npm/next.js';
import { FC, useMemo } from 'react';
import React from 'react';
import { SimilarPurchase as SimilarPurchaseType } from '../../../types/entities.js';
import { AnnounceStartPrice } from '../../Purchases/components/AnnounceStartPrice.js';
import { useIsBiddingForUnit } from '../../Purchases/hooks/useIsBiddingForUnit.js';
import styles from './SimilarPurchase.module.scss';
import { flatten } from 'lodash';

interface Props {
  purchase: SimilarPurchaseType;
}

export const SimilarPurchase: FC<Props> = ({ purchase }) => {
  const isBiddingForUnit = useIsBiddingForUnit(purchase);
  const isPropDisplayNmcFields = useMemo(() => {
    return (
      flatten(purchase.phases.map((phase) => phase.props)).find(
        (prop) => prop.name === 'display_nmc_fields',
      )?.value ?? true
    );
  }, [purchase]);
  return (
    <div className={styles.item} key={purchase.id}>
      <div className={styles.number}>{purchase.number}</div>
      <div className={styles.title}>
        <Link href={`/purchases/${purchase.id}/main`}>{purchase.title}</Link>
      </div>
      <div className={styles.customer}>{purchase.organizer?.shortName}</div>
      {isPropDisplayNmcFields && (
        <div className={styles.price}>
          <AnnounceStartPrice
            lots={purchase.lots}
            isBiddingForUnit={isBiddingForUnit}
            placeholder=""
          />
        </div>
      )}
    </div>
  );
};
